"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMiddlewareRegex = getMiddlewareRegex;

var _routeRegex = require("./route-regex");

function getMiddlewareRegex(normalizedRoute) {
  var catchAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var result = (0, _routeRegex).getParametrizedRoute(normalizedRoute);
  var catchAllRegex = catchAll ? '(?!_next).*' : '';
  var catchAllGroupedRegex = catchAll ? '(?:(/.*)?)' : '';

  if ('routeKeys' in result) {
    if (result.parameterizedRoute === '/') {
      return {
        groups: {},
        namedRegex: "^/".concat(catchAllRegex, "$"),
        re: new RegExp("^/".concat(catchAllRegex, "$")),
        routeKeys: {}
      };
    }

    return {
      groups: result.groups,
      namedRegex: "^".concat(result.namedParameterizedRoute).concat(catchAllGroupedRegex, "$"),
      re: new RegExp("^".concat(result.parameterizedRoute).concat(catchAllGroupedRegex, "$")),
      routeKeys: result.routeKeys
    };
  }

  if (result.parameterizedRoute === '/') {
    return {
      groups: {},
      re: new RegExp("^/".concat(catchAllRegex, "$"))
    };
  }

  return {
    groups: {},
    re: new RegExp("^".concat(result.parameterizedRoute).concat(catchAllGroupedRegex, "$"))
  };
}